export default __webpack_public_path__ + "static/media/Offline.1eeae100.svg";